import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Loader, TsDataSource } from "../../../index";
import { useState } from "react";
function DetailAttribute(props) {
    const { id, endpoint, baseUrl, attribute } = props;
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(true);
    const ds = new TsDataSource({ baseUrl: baseUrl });
    ds.getOne({
        objectType: endpoint,
        id: id,
    }).then((res) => {
        setText(res[attribute] || "");
        setLoading(false);
    });
    return (_jsx("div", { className: "loading-cell", children: loading ? _jsx(Loader, { size: "sm", role: "status", "aria-hidden": true }) : text }));
}
export default DetailAttribute;
